(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["testimonials-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var testimonialSwiper = new Swiper('.swiper-container', {
    slidesPerView: 3,
    spaceBetween: 40,
    loop: true,
    centeredSlides: true,
    autoplay: { delay: 4000 },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: { slidesPerView: 3, spaceBetween: 50 },
      768: { slidesPerView: 2, spaceBetween: 30 },
      480: { slidesPerView: 1, spaceBetween: 20 }
    }
  });

  var prevBtn = document.querySelector('.testimonial-slider .swiper-button-prev');
  var nextBtn = document.querySelector('.testimonial-slider .swiper-button-next');
  if (prevBtn && nextBtn && testimonialSwiper) {
    prevBtn.addEventListener('click', function(e){ e.preventDefault(); testimonialSwiper.slidePrev(); });
    nextBtn.addEventListener('click', function(e){ e.preventDefault(); testimonialSwiper.slideNext(); });
  }
});

  } catch(e) { console.error(e); }
})();
})();
